var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.heading)?_c('div',{staticClass:"b-heading"},[_c('h2',{staticClass:"t-t4",domProps:{"innerHTML":_vm._s(_vm.data.heading)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }